const LABEL = ["", "Safe", "Low risk", "Balanced", "Risky", "Very risky"];
const COLOR = ["", "#10B981", "#34D399", "#F59E0B", "#FB7185", "#F43F5E"];

export const riskFromPrice = (p) => (p == null ? null : p >= 0.8 ? 1 : p >= 0.65 ? 2 : p >= 0.45 ? 3 : p >= 0.25 ? 4 : 5);

export const RiskMeter = ({ level, compact, testid }) => {
  if (!level) return null;
  return (
    <span className="inline-flex items-center gap-1.5" title={`Risk ${level}/5: ${LABEL[level]}`} data-testid={testid || "risk-meter"}>
      <span className="flex gap-[2px]">{[1, 2, 3, 4, 5].map((i) => (
        <span key={i} className="w-1.5 h-3 rounded-[2px]" style={{ background: i <= level ? COLOR[level] : "rgba(255,255,255,0.08)" }} />))}</span>
      {!compact && <span className="text-[10px] font-bold uppercase tracking-wider" style={{ color: COLOR[level] }}>{LABEL[level]}</span>}
    </span>
  );
};

// Plain-English reason a bet lost: the price was the crowd's chance, so losing was the expected outcome some % of the time.
export const lossWhy = (b) => {
  const p = b.entry_price ?? b.entry;
  if (p == null) return null;
  const lose = Math.round((1 - p) * 100);
  const lines = [`You paid ${Math.round(p * 100)}¢, so the market gave this a ${Math.round(p * 100)}% chance. It loses about ${lose} times out of 100.`];
  if (p < 0.3) lines.push("Longshots pay big because they usually lose. One win has to cover many losses.");
  else if (p > 0.7) lines.push("Even strong favourites lose sometimes. One upset can erase several small wins, so keep stakes small and even.");
  else lines.push("Near a coin flip, small edges and fees decide results over many bets, not single ones.");
  if (b.exit_reason === "stop" || b.exit_reason === "stop_loss") lines.push("The bot's stop-loss closed it to cap the loss, as planned.");
  lines.push("Fees are part of the cost on every bet. Judge a strategy over 20+ bets, not one.");
  return lines;
};

export const LossWhy = ({ b, testid }) => {
  const lines = lossWhy(b);
  if (!lines || (b.pnl ?? 0) >= 0) return null;
  return (
    <details className="text-xs text-slate-400 mt-1" data-testid={testid}>
      <summary className="cursor-pointer text-rose-300 font-semibold">Why did I lose?</summary>
      <ul className="list-disc pl-4 mt-1 space-y-0.5">{lines.map((l) => <li key={l}>{l}</li>)}</ul>
    </details>
  );
};
